// Shared date formatting helpers. Field-only dates ("YYYY-MM-DD") render as
// DD/MM/YYYY (es-CO locale) regardless of the browser TZ. ISO datetimes use
// `formatInTz` (in components) which respects the platform-configured TZ.

export function formatDateStr(yyyyMmDd) {
  if (!yyyyMmDd) return "";
  const [y, m, d] = String(yyyyMmDd).split("-");
  if (!y || !m || !d) return yyyyMmDd;
  return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
}
